import { useMemo } from 'react';

import { useAccountFundingFields, useAccountFundingSourceState,useAccountFundingState } from '../../AccountFunding/hooks';

import { useChangesList } from './useChangesList';
import { useFieldsWithSubfields } from './useFieldsWithSubfields';
import { useMatchFields } from './useMatchFields';

const useAccountFundingSummary = () => {
  const state = useAccountFundingState();
  const sourceState = useAccountFundingSourceState();

  const fields = useAccountFundingFields();
  const formattedFields = useMemo(() => fields.map((item) => {
    if (item.name === 'rolloverTimeLimit') {
      return {
        ...item,
        label: 'Rollover time limit',
      };
    }
    return item;
  }), [fields]);
  const { allFields: stateFields } = useFieldsWithSubfields(state, formattedFields);

  const { allFields } = useFieldsWithSubfields(sourceState, formattedFields);
  const list = useMatchFields(state, stateFields);
  const formattedBaseList = useMatchFields(sourceState, allFields);
  const changes = useChangesList(formattedBaseList, list);
  return {
    changes,
  };
};

export default useAccountFundingSummary;
